export default __webpack_public_path__ + "static/media/profile-image-home.cd3e44f8.png";